import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-149e3edc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-4 relative overflow-hidden w-full border border-gray-400 rounded" }
const _hoisted_2 = {
  role: "tablist",
  class: "tab-list"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "max-w-full" }
const _hoisted_5 = {
  class: "example-content overflow-x-auto",
  ref: "previewContainer"
}
const _hoisted_6 = { class: "action-bar" }
const _hoisted_7 = { class: "flex flex-grow justify-end lg:justify-start" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Open ")
const _hoisted_10 = { class: "sr-only" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("example in a new window")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  class: "ml-1 h-5 w-5"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "New window"),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
  })
], -1))
const _hoisted_13 = { class: "action-list" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  class: "example-content overflow-x-auto",
  ref: "previewContainer"
}
const _hoisted_17 = { class: "example-content-inner bg-torbay-primary-grey" }
const _hoisted_18 = { class: "html" }
const _hoisted_19 = { class: "action-bar" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  class: "example-content overflow-x-auto",
  ref: "previewContainer"
}
const _hoisted_22 = { class: "example-content-inner bg-torbay-primary-grey" }
const _hoisted_23 = { class: "html" }
const _hoisted_24 = { class: "action-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UICopyToClipboard = _resolveComponent("UICopyToClipboard")!
  const _directive_highlightjs = _resolveDirective("highlightjs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          role: "tab",
          type: "button",
          class: _normalizeClass(["tab-item", { active: tab.value == _ctx.currentTab }]),
          onClick: _withModifiers(($event: any) => (_ctx.handleTabSelected(tab.value)), ["prevent"])
        }, _toDisplayString(tab.name), 11, _hoisted_3))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "example-content-inner bg-torbay-primary-grey",
            style: _normalizeStyle({ width: _ctx.currentScreenSize })
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.vueComponent)))
          ], 4)
        ], 512),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              href: _ctx.getStandaloneComponentUrl(_ctx.componentId),
              target: "_blank",
              rel: "noopener nofollower",
              class: "inline-flex no-underline items-center rounded-lg font-medium leading-none py-2 px-3 focus:outline-none text-blue-700 hover:bg-gray-200"
            }, [
              _createElementVNode("span", null, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.name), 1),
                _hoisted_11
              ]),
              _hoisted_12
            ], 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.screenSizes, (size) => {
              return (_openBlock(), _createElementBlock("button", {
                role: "tab",
                type: "button",
                class: _normalizeClass(["action-item", { active: size.value == _ctx.currentScreenSize }]),
                onClick: _withModifiers(($event: any) => (_ctx.handleScreenSizeSelected(size.value)), ["prevent"])
              }, _toDisplayString(size.name), 11, _hoisted_14))
            }), 256))
          ])
        ])
      ], 512), [
        [_vShow, _ctx.currentTab == 'preview']
      ]),
      (_ctx.currentTab == 'html')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _withDirectives((_openBlock(), _createElementBlock("pre", null, [
                  _createElementVNode("code", _hoisted_18, _toDisplayString(_ctx.htmlCode), 1)
                ])), [
                  [_directive_highlightjs]
                ])
              ])
            ], 512),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_UICopyToClipboard, { value: _ctx.htmlCode }, null, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentTab == 'vue')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives((_openBlock(), _createElementBlock("pre", null, [
                  _createElementVNode("code", _hoisted_23, _toDisplayString(_ctx.vueCode), 1)
                ])), [
                  [_directive_highlightjs]
                ])
              ])
            ], 512),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_UICopyToClipboard, { value: _ctx.vueCode }, null, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}